import { IApprovalRequest } from '../Approval'
import { IDocument } from '../cloud/database/DatabaseItemsDefinitions'
import { IFlow } from '../Nodes'
import { ISettlementSchema } from '../SettlementSchema'

export interface ICompiledReport extends IDocument {
    uuid: string
    reportName: string
    executionEnviromentUUID: string
    userUUID: string
    contractId: number
    reportUUID: string
    fileKey: string
    createdAt: string
    fileSize: number
}

export interface IReport extends IDocument {
    name: string
    updatedAt: string
    createdAt: string
    createdBy: string
    sections: IReportSection[]
    pageOrientation: ReportPageOrientation
    pageSize: ReportPageSize
}

export interface ICompiledReportInfo extends ICompiledReport {
    from: string
    to: string
    groupKey: string
    approval?: IApprovalRequest
    reportTemplateName: string
    runnedBy: string
    flowUUID: string
    flowName: string
    flowVersion?: IFlow['versioning']
    contractVersion: number
    settlementVersion?: ISettlementSchema['versioning']
    settlementName: string

}

export type ReportSectionType = '1-column' | '2-columns' | '3-columns'
export const ALL_REPORT_SECTION_TYPES: ReportSectionType[] = ['1-column', '2-columns', '3-columns']

export type ReportPageOrientation = 'portrait' | 'landscape'
export const ALL_REPORT_PAGE_ORIENTATION: ReportPageOrientation[] = ['portrait', 'landscape']

export type ReportPageSize = 'A3' | 'A4'
export const ALL_REPORT_PAGE_SIZE: ReportPageSize[] = ['A3', 'A4']

export interface IReportSection {
    uuid: string
    type: ReportSectionType
    columns: ISectionColumn[]
}

export type SectionColumnType = 'text' | 'image' | 'table' | 'chart' | 'spacer'
export const ALL_REPORT_COLUMN_TYPES: SectionColumnType[] = ['text', 'image', 'table', 'chart', 'spacer']

// General Layout
export type TableBorderStyle = 'none' | 'all'

export interface ISectionColumn {
    uuid: string
    name?: string
    type: SectionColumnType
    settings: any
}

export type SectionColumnSettingsMap = {
    text: {
        content: string
    }
    image: {
        fileKey: string
        height: number
        alignment: 'left' | 'center' | 'right'
    }
    table: {
        columns: IReportTableColumn[]
        rows: IReportTableRow[]
        generalStyle?: TableGeneralStyle
    }
    chart: {
        columns: []
        rows: []
    }
    spacer: object
}

export interface TableGeneralStyle {
    borderStyle?: TableBorderStyle
}

// New border interfaces
export interface IDataSetBorders {
    inner?: boolean
    outside?: boolean
    top?: boolean
    bottom?: boolean
    left?: boolean
    right?: boolean
    innerHorizontal?: boolean
    innerVertical?: boolean

}

export interface IColumnBorders {
    top?: boolean
    bottom?: boolean
    left?: boolean
    right?: boolean
}

export interface IReportTableColumn {
    uuid: string
    key: string
    label: string
    width?: number
    headerStyle?: ITableCellStyle
    cellStyle?: ITableCellStyle
    subColumns?: IReportTableColumn[]
    formatNumbers?: boolean
    borders?: IColumnBorders
    formatNumbersPercentage?: boolean
    formatNumbersNoDollar?: boolean
}

export interface IReportTableRow {
    value?: string
    data?: Record<string, any> | any[]
    rowStyle?: ITableCellStyle
    cellStyles?: Record<string, ITableCellStyle>
    isSpacer?: boolean
    formatNumbers?: boolean
    borders?: IDataSetBorders
    formatNumbersPercentage?: boolean
    formatNumbersNoDollar?: boolean
}

export interface ITableCellStyle {
    bold?: boolean
    color?: string
    strike?: boolean
    background?: string
    alignment?: 'left' | 'center' | 'right'
}

export interface EditorProps<T extends keyof SectionColumnSettingsMap> {
    column: ISectionColumn
    onChange: (settings: SectionColumnSettingsMap[T]) => void
}

export interface IPreviewURI {
    key: string
    url: string
}

export interface IReportPlaceholder {
    name: string
    contents: string[]
    columns?: string[]
}
